<template>
  <v-dialog v-model="open" max-width="50vw" @click:outside="() => $emit('exit')">
    <ValidationObserver ref="job" v-slot="{ invalid, validated, passes }">
      <v-card>
        <v-card-title>
          <span class="headline">Job</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <ValidationProvider v-slot="{ errors }" name="title" rules="required|max:50">
                  <v-text-field v-model="job.name" label="Job Title*" :error-messages="errors" required></v-text-field>
                </ValidationProvider>
              </v-col>
              <div class="flex-grow-1"></div>
              <v-col cols="12" sm="6" md="5">
                <ValidationProvider v-slot="{ errors }" name="organisation" rules="required">
                  <v-autocomplete
                    v-model="org"
                    label="Assignee's Organisation"
                    :items="orgs"
                    item-text="name"
                    item-value="id"
                    :item-disabled="(j) => j.disabled === 'True'"
                    :error-messages="errors"
                    :disabled="mode !== 'new'"
                    required
                  ></v-autocomplete>
                </ValidationProvider>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-textarea v-model="job.description" name="input-7-1" label="Job Description"></v-textarea>
              </v-col>
              <div class="flex-grow-1"></div>
              <v-col cols="12" sm="6" md="5">
                <ValidationProvider v-if="org" v-slot="{ errors }" name="Asignee" rules="required|email">
                  <v-autocomplete
                    v-model="job.assigned_to"
                    label="Assignee"
                    :items="orgUsers"
                    item-text="name"
                    item-value="email"
                    :error-messages="errors"
                    required
                  ></v-autocomplete>
                </ValidationProvider>

                <v-dialog ref="dialog" v-model="modal" :return-value.sync="job.due_on" persistent width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field v-model="date" label="Due Date" prepend-icon="mdi-calendar" readonly v-on="on"></v-text-field>
                  </template>
                  <v-date-picker v-model="job.due_on" scrollable>
                    <div class="flex-grow-1"></div>
                    <v-btn text color="primary" @click="modal = false">Cancel</v-btn>
                    <v-btn text color="primary" @click="$refs.dialog.save(job.due_on)">OK</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-sheet color="mx-auto grey light-1" max-width="50vw">
                  <v-slide-group ref="slide" v-model="task" class="pa-4" show-arrows>
                    <v-slide-item v-for="(t, i) in tasks" :key="i">
                      <v-card class="ma-4 pa-1" height="100%" width="300" @click="editTask(t)">
                        <v-card-title>{{ t.name }}</v-card-title>
                        <otc v-if="mode !== 'new'" :task="t" />
                        <v-card-text>
                          <div>
                            Action: {{ mapJobTypeLabels(t.task_type) }}
                          </div>
                          <br />
                          <div v-if="t.num_devices">
                            Number: {{ t.num_devices }}
                            <br />
                          </div>
                          
                          <div>
                            Assignee: {{ t.assigned_to }}
                          </div>
                          <!-- <br />
													Note: {{t.extra_install_instructions}}-->
                        </v-card-text>
                        <v-card-actions>
                          <div class="flex-grow-1"></div>
                          <v-btn text color="warning" @click.stop.prevent="delTask(i)">Delete</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-slide-item>
                    <v-slide-item key="add">
                      <div class="d-flex ma-4 pa-1" style="width:100px; height:100%; justify-content:center; align-items: center;">
                        <add-task 
                          v-if="displayTaskBtn"
                          ref="addTask" 
                          :init-details="details" 
                          :org-users="orgUsers"
                          :job-item="jobItem"
                          :orgs="orgs"
                          @task="handletask" 
                          @setTaskType="handleTaskType"
                          @exit="() => $refs.job.validate()"
                          @taskCreated="hideTaskBtn"
                        />
                      </div>
                    </v-slide-item>
                  </v-slide-group>
                </v-sheet>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="blue darken-1" text @click="$emit('exit')">Cancel</v-btn>
          <v-btn color="blue darken-1" text :loading="loading" :disabled="invalid || !validated || tasks.length === 0" @click="passes(submit)">Submit</v-btn>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
    <v-dialog v-model="clearTask" max-width="290">
      <v-card>
        <v-card-title class="headline">Change Organisation?</v-card-title>

        <v-card-text>All tasks will be removed</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="clearTask = false">Cancel</v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="
              tasks = []
              clearTask = false
            "
            >Continue</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>

import { mapState } from "vuex"

import { 
  NewJob,
  UpdateJob, 
  ListOrgUsers 
} from "@/services/API.js"

import { AmplifyEventBus } from "aws-amplify-vue"

import moment from "moment"

import OTC from "./OTC"
import AddTask from "./AddTask"

import { Logger } from "aws-amplify"
const logger = new Logger("AddJob")

const defaultjob = () => ({
  due_on: moment().format("YYYY-MM-DD"),
  name: "",
  assigned_to: "",
  description: "",
})

export default {
  name: 'AddJob',
  components: {
    Otc: OTC,
    AddTask,
  },
  props: {
    open: {
      required: true,
      type: Boolean,
    },
    mode: {
      required: true,
      type: [String, Object],
    },
    jobItem: {
      required: false,
      type: Object,
      default: () => null
    }
  },
  data: () => ({
    modal: false,
    clearTask: false,
    loading: false,
    org: "",
    orgUsers: [],
    tasks: [],
    task: null,
    job: {
      due_on: moment().format("YYYY-MM-DD"),
      name: "",
      assigned_to: "",
      description: "",
      job_type: ""
    },
    details: {
      name: '',
      assigned_to: ''
    },
    displayTaskBtn: true,
    taskMap: {
      'install': 'Install',
      'firmware_job': 'Firmware Update',
      'device_config_job': 'Device Configuration'
    }
  }),

  computed: {
    date() {
      if (!this.job.due_on || this.job.due_on === "Invalid date") return moment().format("YYYY-MM-DD")
      
      return moment(this.job.due_on).format("DD/MM/YYYY")
    },
    ...mapState(["orgs"]),
  },

  watch: {
    open(val) {
      if (!val) return

      // Show create new task button when opening
      this.displayTaskBtn = true;
      
      if (this.mode === "new") {
        this.job = defaultjob()
        this.org = ""
        this.tasks = []
        this.$nextTick(() => {
          this.$refs.job.reset()
        })
      }

      if (typeof this.mode === "object") {
        this.actions = new Map()
        this.index = 0
        this.job = this.mode
        this.job.due_on = moment(this.mode.due_on).format("YYYY-MM-DD")
        this.org = this.mode.org
        this.tasks = Array.from(this.mode.Tasks)
        this.$nextTick(() => {
          // this.$refs.job.validate();
          this.$refs.job.reset()
          const unwatch = this.$watch(
            "job",
            () => {
              this.$refs.job.validate()
              unwatch()
            },
            {
              deep: true,
            }
          )
        })
      }

      requestAnimationFrame(() => {
        this.$refs.slide.onResize()
      })
    },
    org(newVal, oldVal) {
      logger.info('org has changed : ', this.org);
      if (this.org) {
        this.getOrgUsers(this.org);
      }

      if (newVal && oldVal && newVal !== oldVal && this.tasks.length > 0) {
        this.clearTask = true
      }
    },
    job: {
      handler(){
        this.details.name = this.job.name;
        this.details.assigned_to = this.job.assigned_to;
        this.details.due_on = this.job.due_on;
     },
     deep: true  
    },
  },
  methods: {
    mapJobTypeLabels(item) {
      if (!Object.hasOwn(this.taskMap, item)) return;

      return this.taskMap[item];
    },  
    getOrgUsers(id) {
      ListOrgUsers(id)
      .then(res => {
        this.orgUsers = res.Users.map(user => {
          user.name = user.firstName + " " + user.lastName;
          return user;
        });
      })
      .catch(err => {
        this.orgUsers = [];
        logger.info('there was an error ', err);
      })
    },
    hideTaskBtn() {
      this.displayTaskBtn = false;
    },
    editTask(task) {
      this.$refs.addTask.editTask(task)
    },
    delTask(index) {
      logger.debug(index, this.tasks)
      if (this.mode !== "new") {
        if (this.tasks[index].id) {
          this.actions.set(this.tasks[index].id, {
            action: "delete",
            task_id: this.tasks[index].id,
          })
        } else if (this.actions.has(this.tasks[index].index)) {
          this.actions.delete(this.tasks[index].index)
        }
      }
      this.tasks = this.tasks.filter((t, i) => i !== index)
    },
    handletask(item) {
      logger.info("handletask", item)
      if (this.mode !== "new") {
        if (item.mode === "new") {
          this.index++
          item.task.index = this.index
          this.actions.set(this.index, {
            action: "create",
            name: item.task.name,
            description: item.task.description,
            assigned_to: item.task.assigned_to,
            performed_by: item.task.performed_by,
            status: item.task.status,
            task_type: item.task.task_type,
            due_on: item.task.due_on
          })
        } else {
          this.actions.has(item.task.index)
            ? this.actions.set(item.task.index, {
                action: "create",
                name: item.task.name,
                description: item.task.description,
                assigned_to: item.task.assigned_to,
                performed_by: item.task.performed_by,
                status: item.task.status,
                task_type: item.task.task_type,
                due_on: item.task.due_on
              })
            : this.actions.set(item.task.id, {
                action: "update",
                ...item.task,
              })
        }
      }

      if (item.mode === "new") {
        this.tasks.push(item.task)
      } else {
        const index = this.tasks.findIndex((t) => t.id === item.task.id)
        this.$set(this.tasks, index, item.task)
      }

      this.$refs.job.validate()
    },
    handleTaskType(type) {
      this.job.job_type = type;
    },
    async submit() {
      this.loading = true;
      if (this.mode === "new") {
        let tasks = this.tasks;
        this.tasks.forEach(async (item) => {
          logger.info('testing ', item)
          if (this.job.job_type == 'otc_job') {
            this.job.org = this.org
          }
          if (item.task_type === "firmware_job") {  
            let firmware_id = '';

            this.tasks.forEach(task => {
              firmware_id = task.context.firmware_id;
            });

            this.job.org = this.org;
            this.job.firmware_id = firmware_id;
            logger.info('check firmware job : ', this.job);
          }

          const params = {
            ...this.job,
            due_on: this.job.due_on,
            tasks
          }
          
          logger.info('checking job params : ', params)

          const res = await NewJob(params);
          logger.debug(res)
          if (res) {
            
            // Emit new job
            this.$emit('latestJob', res);


            this.$emit("exit")
            AmplifyEventBus.$emit("job-now", {
              action: "add",
              job: res,
            })
            this.loading = false
          }
          else {
            this.loading = false
          }
        });        
      } 
      else if (this.actions && this.actions.size > 0) {
        const tasks = []
        this.actions.forEach((action) => {
          if (action.action === "update") {
            tasks.push({
              action: action.action,
              task_id: action.id,
              name: action.name,
              description: action.description,
              assigned_to: action.assigned_to,
              performed_by: action.performed_by,
              status: action.status,
              task_type: action.task_type,
              due_on: action.due_on,
              extra_install_instructions: action.extra_install_instructions,
            })
          } else {
            tasks.push(action)
          }
        })
        const params = {
          assigned_to: this.job.assigned_to,
          description: this.job.description,
          name: this.job.name,
          due_on: this.job.due_on,
          Tasks: tasks,
        }
        this.loading = true
        const res = await UpdateJob(this.job.id, params)
        logger.debug(res)
        this.loading = false
        if (res) {
          this.$emit("exit")
          AmplifyEventBus.$emit("job-now", {
            action: "modify",
            job: res,
          })
        }
        else {
            this.loading = false
          }
      }
    },
  },
}
</script>
